export const L10N = {
  ACTION_BOOK: { id: 'core.action.book' },
  ACTION_FINAL_DETAILS: { id: 'core.action.final_details' },
  ACTION_PROCEED_TO_PAYMENT: { id: 'core.action.proceed_to_payment' },
};
